module.exports = __webpack_public_path__ + "static/media/roxSplash.7522cf34.svg";